export default "__VITE_ASSET__DB4mNhK9__"